export const getExtensionFromFileName = (fileName: string) => {
  if (typeof fileName !== 'string') {
    return null;
  }

  const parts = fileName.split('.');
  if (parts.length < 2) {
    return null;
  }

  const extension = parts.pop()?.toLowerCase().trim();

  return extension?.includes(' ') ? null : extension;
};

export const replaceFileExtension = (
  filename: string,
  newExtension: string
) => {
  // Remove the existing extension
  const baseFilename = filename.replace(/\.[^/.]+$/, '');

  // Add the new extension (ensure it starts with a dot if not provided)
  return `${baseFilename}.${newExtension.replace(/^\./, '')}`;
};

export const sanitizeFileName = (filename: string) => {
  const defaultFilename = 'unknown_file';

  if (!filename || typeof filename !== 'string') {
    return defaultFilename;
  }

  return filename
    .replace(/[^a-zA-Z0-9.\-_]/g, '_') // Replace unsafe characters with underscores
    .replace(/\.+/g, '.') // Replace multiple dots with single dot
    .replace(/^\.+|\.+$/g, '') // Remove leading/trailing dots
    .substring(0, 255);
};
